import { render, staticRenderFns } from "./KinvaItemForm.vue?vue&type=template&id=67637dd6&scoped=true"
import script from "./KinvaItemForm.vue?vue&type=script&lang=js"
export * from "./KinvaItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67637dd6",
  null
  
)

export default component.exports